<template>
  <div>
    <v-layout v-if="!isMobile" class="client-account-container">
      <v-flex class="client-account-container-column">
        <client-setting-page
          :profile="clientData"
          @after-profile-update="updateClientProfile($event)"
        />
      </v-flex>
      <v-flex class="client-account-container-column">
        <client-need-want
          :preference-type="'Need'"
        />
        <client-need-want
          :preference-type="'Want'"
        />
      </v-flex>
      <v-flex class="client-account-container-column">
        <agent-broker-info
          :profile="associatedAgent"
        />
        <client-documents
          :profile="clientData"
        />
      </v-flex>
    </v-layout>
    <div v-else class="container-tab container-tab-mobile">
      <client-setting-page
        v-if="bottomNav === 'general'"
        :profile="clientData"
        @after-profile-update="updateClientProfile($event)"
      />
      <v-container v-if="bottomNav === 'needs'">
        <need-want-tab :preference-type="'Need'" />
      </v-container>
      <v-container v-if="bottomNav === 'wants'">
        <need-want-tab :preference-type="'Want'" />
      </v-container>
      <v-card class="bottom-nav" flat>
        <v-bottom-nav
          :active.sync="bottomNav"
          :value="true"
          color="transparent"
        >
          <v-btn color="teal" flat value="general">
            <span>General</span>
            <v-icon>account_circle</v-icon>
          </v-btn>

          <v-btn color="teal" flat value="needs">
            <span>Needs</span>
            <v-icon>view_array</v-icon>
          </v-btn>
          <v-btn color="teal" flat value="wants">
            <span>Wants</span>
            <v-icon>view_array</v-icon>
          </v-btn>
        </v-bottom-nav>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import ClientSettingPage from '../../components/common/ClientSettingPage.vue'
import NeedWantTab from '../../components/client/account/NeedWantTab.vue'
// import DocumentsTab from '../../components/client/account/DocumentsTab.vue'
import AgentBrokerInfo from '../agent/AgentBrokerInfo'
import ClientNeedWant from '../../components/client-detail/Components/ClientNeedWant'
import ClientDocuments from '../../components/client-detail/Components/ClientDocuments'
import colors from '../../scss/_colors.scss'

export default {
  components: {
    ClientSettingPage,
    AgentBrokerInfo,
    ClientNeedWant,
    ClientDocuments,
    NeedWantTab
  },

  data() {
    return {
      bottomNav: 'general',
      active: null,
      tabs: [
        'profile',
        'needs',
        'wants',
        'documents',
        'agent info'
      ],
      tabTitles: [
        'PROFILE INFORMATION',
        'YOUR NEEDS',
        'YOUR WANTS',
        'DOCUMENTS',
        'AGENT INFO'
      ],
      accountTabColor: colors.hwayzec,
      showWantsModal: false,
      showNeedsModal: false,
      preferenceType: null

    }
  },

  computed: {
    ...mapState('client', ['clientData', 'associatedAgent']),
    ...mapState('common', ['isMobile'])
  },

  methods: {
    ...mapMutations('client', {
      setClientData: 'SET_CLIENT_DATA'
    }),
    updateClientProfile(data) {
      this.setClientData(data)
    },
    updateClientDocuments(data) {
      this.setClientData(data)
    }
  }
}
</script>

<style lang="sass" scoped>
.bottom-nav
  position: fixed
  bottom: 0
  left: 0
  width: 100%
  z-index: 2
.v-sheet
  border-radius: 0 !important

.container-tab
  background-color: $hwyzAccountTabClient
  height: 100%

.container-tab-mobile
  padding-bottom: 60px

.tab-title
  font-size: 1.6rem
  display: block
  padding-bottom: 3rem
.client-account-container
  display: flex
  justify-content: center
  flex-flow: row wrap
  @media only screen and (max-width: 500px)
    flex-direction: column
.client-account-container-column
  display: flex
  flex-flow: column
  justify-content: flex-start
  width: 32%
  align-items: stretch
  @media only screen and (max-width: 1020px)
    width: 100% !important
    margin-top: 2rem !important
.client-account-container-column:not(:first-child)
  margin-left: 2rem
  @media only screen and (max-width: 1020px)
    margin-left: 0
.client-account-container-column .client-need-want:nth-child(2), .client-account-container-column .client-documents
  margin-top: 2rem
</style>
